@if (!item()!.hidden) {
  <li data-username="able-pro dashboard" class="nav-item coded-hasmenu" [routerLinkActive]="['active']">
    <a [routerLinkActive]="['active']" class="nav-link" (click)="navCollapse($event)">
      @if (item()!.icon) {
        <span class="coded-micon">
          <i class="{{ item().icon }}"></i>
        </span>
      }
      <span class="coded-mtext">{{ item()!.title | translate }}</span>
    </a>
    <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item()!.classes!">
      @for (items of item()!.children; track $index) {
        @if (items.type === 'item') {
          <app-menu-item [item]="items" [parentRole]="item()!.role && item()!.role!.length > 0 ? item()!.role : parentRole.role" />
        } @else if (items.type === 'collapse') {
          <app-menu-collapse [item]="items" [parentRole]="item()!.role && item()!.role!.length > 0 ? item()!.role : parentRole.role" />
        }
      }
    </ul>
  </li>
}
